// The AI diamond: marks anything AI worked out (reading an email or a web page, the scam
// risk score, comparing logos), so people can tell it from what our own checks proved.
//   <AiMark />              the diamond on its own (with a tooltip)
//   <AiMark label />        the diamond and the word "AI"
//   isAiReason(reason)      true for a reason AI produced

export function isAiReason(r) {
  return !!r && (String(r.code || '').startsWith('ai_') || /\b(by AI|AI reading)\b/.test(String(r.text || '')));
}

export default function AiMark({ label = false, title = 'Worked out by AI' }) {
  return (
    <span className="ai-mark" title={title}>
      <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 1.5c.6 4.9 2.4 8.4 10.5 10.5C14.4 14.1 12.6 17.6 12 22.5 11.4 17.6 9.6 14.1 1.5 12 9.6 9.9 11.4 6.4 12 1.5z" fill="currentColor" />
      </svg>
      {label ? <span>AI</span> : <span className="sr-only">{title}</span>}
    </span>
  );
}
